import React from 'react';
import '../../../../../../CSS/Dashboard/portfolio.scss';
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"

// import "./styles.css";


// import Swiper core and required modules
import SwiperCore, {
  Navigation
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation]);

const Carousel = ({images,height = '520px', width = '100%'})=>{
    // console.log(images);
    return (
        <div>
            <Swiper navigation={true} className="mySwiper">
            {images && images.map((image)=>{
                        return (
                            <SwiperSlide>
                                <img 
                                className="img-responsive"
                                style={{height: height,width: width}} src={image.url} className="d-block w-100" alt="..."/>
                            </SwiperSlide>
                        )
                    })}
            </Swiper>
        </div>
    )
}
export default Carousel;